import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material';


export default function ModernAlertDialog({ open, handleClose, title, msg }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // Estilização 
      PaperProps={{
        sx: {
          borderRadius: '24px', 
          padding: '20px',
          maxWidth: '620px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0px 10px 40px rgba(1, 36, 67, 0.15)', 
        },
      }}
    >
      {/* Cabeçalho com Ícone e Título */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1 }}>
        {/* Círculo de fundo para o ícone  */}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 49, 0, 0.1)', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <i
            className="fa fa-bell"
            aria-hidden="true"
            style={{ fontSize: '28px', color: '#FF3100' }} 
          ></i>
        </Box>

        <Typography 
          id="alert-dialog-title" 
          variant="h5" 
          sx={{ 
            color: '#012443', 
            fontWeight: 700,
            fontFamily: 'sans-serif' 
          }}
        >
          {title || "Atenção"}
        </Typography>
      </Box>

      {/* Conteúdo da Mensagem (Renderizando o Array) */}
      <DialogContent sx={{ p: 2 }}>
        <Box id="alert-dialog-description">
          {Array.isArray(msg) && msg.length > 0 ? (
            msg.map((item, index) => (
              <Typography 
                key={index} 
                variant="body1" 
                sx={{ 
                  color: '#555', 
                  fontSize: '1rem', 
                  marginBottom: '8px',
                  lineHeight: 1.5 
                }}
              >
                {item}
              </Typography>
            ))
          ) : (
            // Fallback caso venha uma string simples
            <Typography variant="body1" sx={{ color: '#555' }}>
              {msg}
            </Typography>
          )}
        </Box>
      </DialogContent>

      {/* Ações  */}
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: '#FF3100', 
            color: '#FFF',
            borderRadius: '50px', 
            padding: '10px 40px',
            textTransform: 'none', 
            fontSize: '1rem',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#D62900', // Um tom levemente mais escuro para hover
            },
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}